import React, { useState } from "react";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  const [i, setI] = useState(0);
  const t = testimonials[i];
  const prev = () => setI((v) => (v - 1 + testimonials.length) % testimonials.length);
  const next = () => setI((v) => (v + 1) % testimonials.length);

  return (
    <section id="testimonials" className="icg-section bg-[color:var(--icg-cream-soft)]">
      <div className="icg-container">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="icg-eyebrow">
              <span className="icg-dot" /> What clients say
            </span>
            <h2
              className="font-display font-semibold tracking-tight mt-5"
              style={{ fontSize: "clamp(36px, 5vw, 64px)", lineHeight: 1.02 }}
            >
              Trusted by teams<br />
              at{" "}
              <span className="font-serif-it text-[color:var(--icg-accent)]">
                Fortune 500s
              </span>
              .
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <button
              aria-label="Previous"
              onClick={prev}
              className="h-11 w-11 rounded-full border border-[color:var(--icg-ink)] hover:bg-[color:var(--icg-ink)] hover:text-[color:var(--icg-cream)] transition-colors flex items-center justify-center"
            >
              <ChevronLeft size={18} />
            </button>
            <button
              aria-label="Next"
              onClick={next}
              className="h-11 w-11 rounded-full border border-[color:var(--icg-ink)] hover:bg-[color:var(--icg-ink)] hover:text-[color:var(--icg-cream)] transition-colors flex items-center justify-center"
            >
              <ChevronRight size={18} />
            </button>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-4">
            <div className="relative rounded-3xl overflow-hidden aspect-square bg-[color:var(--icg-cream)]">
              <img
                key={t.image}
                src={t.image}
                alt={t.name}
                className="w-full h-full object-cover icg-fade-up"
              />
            </div>
            <div className="mt-5">
              <div className="font-display text-xl font-semibold">{t.name}</div>
              <div className="text-sm text-[color:var(--icg-muted)]">
                {t.role} · {t.company}
              </div>
            </div>
          </div>

          <div className="md:col-span-8 md:pl-8">
            <Quote
              size={44}
              className="text-[color:var(--icg-accent)]"
              strokeWidth={1.4}
            />
            <p
              key={t.id}
              className="mt-6 font-display font-medium tracking-tight text-[color:var(--icg-ink)] icg-fade-up"
              style={{ fontSize: "clamp(22px, 2.4vw, 34px)", lineHeight: 1.25 }}
            >
              &ldquo;{t.quote}&rdquo;
            </p>

            <div className="mt-10 flex items-center gap-2">
              {testimonials.map((_, idx) => (
                <button
                  key={idx}
                  aria-label={`Testimonial ${idx + 1}`}
                  onClick={() => setI(idx)}
                  className={`h-1.5 rounded-full transition-all ${
                    idx === i
                      ? "w-8 bg-[color:var(--icg-ink)]"
                      : "w-4 bg-[color:var(--icg-line)]"
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
